module.exports = __webpack_public_path__ + "static/media/petDogNew.6710c588.svg";